var _clipPath, _clipPath2, _path, _path2, _path3, _g, _path4, _rect, _g2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnlockColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 72.3 64.07",
  width: 72.3,
  height: 64.07,
  preserveAspectRatio: "xMidYMid meet",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "m63.3 39.75-4.98-.45 2.03-22.16c.56-6.11-3.96-11.53-10.06-12.09-6.11-.56-11.53 3.96-12.09 10.06l-.52 5.69-1.82 1.34 1.68.18-.21 2.33-4.98-.45.87-9.53c.81-8.87 8.67-15.41 17.52-14.6s15.4 8.67 14.59 17.52z"
}))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  height: 31.34,
  rx: 2.21,
  transform: "matrix(.99710607 -.07602294 .07602294 .99710607 -3.43 3.93)",
  width: 42.91,
  x: 28.42,
  y: 31.31
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m63.3 39.75-4.98-.45 2.03-22.16c.56-6.11-3.96-11.53-10.06-12.09-6.11-.56-11.53 3.96-12.09 10.06l-.52 5.69-1.82 1.34 1.68.18-.21 2.33-4.98-.45.87-9.53c.81-8.87 8.67-15.41 17.52-14.6s15.4 8.67 14.59 17.52z",
  fill: "#708483"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m31.15 27.32-14.76-4c-1.14-.33-.68-2.04.47-1.74.01 0 14.53 4.87 14.55 4.88.54.18.3 1.01-.26.86z",
  fill: "#db831b"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m29.01 30.33-11.03-.55c-1.18-.08-1.1-1.84.09-1.8.07 0 10.95 1.45 11.02 1.46.56.07.49.93-.08.9z",
  fill: "#db831b"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m60.08 36.52 1.86-19.51c.68-7.47-4.84-14.1-12.31-14.78s-14.1 4.84-14.78 12.31l-1.21 12.08",
  fill: "none",
  stroke: "#a5b7b6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.23
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "m7.96 24.97-3.41 2.14c-.58.36-1.31-.09-1.25-.77l.38-4.01c.03-.27-.08-.53-.29-.71l-3.09-2.58c-.52-.44-.32-1.28.35-1.43l3.93-.88c.26-.06.48-.24.58-.49l1.5-3.74c.25-.63 1.12-.7 1.46-.11l2.05 3.47c.14.23.38.38.65.4l4.02.27c.68.05 1.01.85.56 1.36l-2.66 3.02c-.18.2-.25.48-.18.74l.98 3.91c.17.66-.5 1.22-1.12.95l-3.7-1.6c-.25-.11-.53-.09-.76.06z",
  fill: "#f2ce1d"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#f4a721",
  height: 31.34,
  rx: 2.21,
  transform: "matrix(.99710607 -.07602294 .07602294 .99710607 -3.43 3.93)",
  width: 42.91,
  x: 28.42,
  y: 31.31
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)",
  fill: "#ffff73"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.77 40.52h57.46v5.97h-57.46z",
  opacity: 0.35,
  transform: "matrix(.79260901 -.60973024 .60973024 .79260901 -16.47 38.59)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24.67 48.09h57.46v3.94h-57.46z",
  opacity: 0.35,
  transform: "matrix(.79260901 -.60973024 .60973024 .79260901 -19.45 42.94)"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m57.38 56.35-4.03-5.9c1.97-1.34 3.2-3.67 3-6.22-.29-3.8-3.6-6.64-7.4-6.35s-6.64 3.6-6.35 7.4c.19 2.55 1.76 4.67 3.91 5.7l-3.09 6.44 13.96-1.06z",
  fill: "#d8681d",
  stroke: "#ffd345",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.63
})));
export default SvgUnlockColor;